export default {
  dataIterator: {
    rowsPerPageText: 'รายการต่อหน้า:',
    rowsPerPageAll: 'ทั้งหมด',
    pageText: '{0}-{1} จาก {2}',
    noResultsText: 'ไม่พบรายการที่ตรงกัน',
    nextPage: 'หน้าถัดไป',
    prevPage: 'หน้าก่อนหน้า'
  },
  dataTable: {
    rowsPerPageText: 'แถวต่อหน้า:'
  },
  noDataText: 'ไม่มีข้อมูล',
  carousel: {
    prev: 'ภาพก่อนหน้า',
    next: 'ภาพถัดไป'
  },
  errors: {
    codeIncorrect: 'รหัสไม่ถูกต้อง',
    errorLogin: 'เกิดข้อผิดพลาดในการเข้าสู่ระบบ',
    qr: {
      notAllowed: 'ข้อผิดพลาด: คุณต้องอนุญาตการเข้าถึงกล้อง',
      notFound: 'ข้อผิดพลาด: ไม่พบกล้องบนอุปกรณ์นี้',
      notSupported: 'ข้อผิดพลาด: ต้องใช้การเชื่อมต่อที่ปลอดภัย (HTTPS, localhost)',
      notReadable: 'ข้อผิดพลาด: กล้องถูกใช้งานอยู่หรือไม่?',
      overConstrained: 'ข้อผิดพลาด: กล้องที่ติดตั้งไม่เหมาะสม',
      streamAPINotSupported: 'ข้อผิดพลาด: เบราว์เซอร์นี้ไม่รองรับ Stream API',
      scanFailed: 'รหัส QR ไม่ถูกต้อง',
      tableNumberFailed: 'หมายเลขโต๊ะไม่ถูกต้อง'
    },
    location: {
      inStoreTitle: 'ตำแหน่งปัจจุบันของคุณไม่ได้อยู่ในร้าน',
      inStoreDescription: 'คุณไม่สามารถสั่งอาหารแบบนั่งทานที่ร้านได้ โปรดเลือกรับเองหรือจัดส่ง',
      inStoreBtn: 'ตกลง',
      locationDisabledTitle: 'โปรดอนุญาตตำแหน่ง GPS',
      locationDescription: 'โปรดสแกนรหัส QR อีกครั้ง, และอนุญาตตำแหน่ง GPS, หรือเปิดใช้งานโดยตรงจากการตั้งค่าโทรศัพท์ของคุณ',
      locationBtn: 'ตกลง'
    },
    cart: {
      menuUnavailable: 'เมนูไม่พร้อมให้บริการในช่วงเวลาเหล่านี้',
      startShopping: 'เริ่มสั่งอาหาร'
    },
    schedule: {
      availableTimes: '{0} สามารถใช้ได้เฉพาะเวลา {1} - {2}',
      unavailableTimes: '{0} ไม่พร้อมให้บริการเวลา {1} - {2}',
      availableDay: '{0} จะพร้อมให้บริการในวันที่ {1} เวลา {2}',
      unavailable: '{0} ไม่พร้อมให้บริการในขณะนี้ ลองเลือกประเภทการสั่งซื้ออื่น',
      startScheduling: 'คุณสามารถเริ่มกำหนดเวลาการสั่งซื้อได้ในวันที่ {0} เวลา {1}'
    },
    paymentUnsuccessful: 'การชำระเงินไม่สำเร็จ',
    temporarilyAppear: 'การเรียกเก็บเงินนี้อาจปรากฏในรายการเดินบัญชีของคุณชั่วคราวก่อนที่จะถูกลบออก',
    pageNotFound: 'ไม่พบหน้า',
    storeNotFoundMessage: 'ไม่พบร้านที่คุณกำลังค้นหา อาจมีการย้าย ลบ หรือ URL ไม่ถูกต้อง'
  },
  common: {
    storeHoursClosedHoliday: 'ปิด',
    today: 'วันนี้',
    nextAvailable: 'พร้อมให้บริการถัดไป',
    referralButtonText: 'ชวนเพื่อนของคุณ',
    pointsEarned: 'คะแนนที่ได้รับ',
    confirmTitle: 'โปรดยืนยัน',
    confirmDesc: 'คุณแน่ใจหรือไม่ว่าต้องการเปลี่ยนจากการสั่งอาหารแบบนั่งทานที่ร้าน?',
    actionText: 'ใช่, เปลี่ยน',
    pickup: 'รับเอง',
    delivery: 'จัดส่ง',
    availableToDeliver: 'พร้อมจัดส่ง',
    notAvailableForDelivery: 'ไม่พร้อมจัดส่ง',
    loginDescription: 'ลงทะเบียนหรือเข้าสู่ระบบตอนนี้เพื่อปลดล็อกคูปองพิเศษ, รางวัล, และข้อเสนอที่ปรับแต่งมาเพื่อคุณโดยเฉพาะ!',
    orderNow: 'สั่งเลย',
    hours: 'ชั่วโมงทำการ',
    location: 'สถานที่ตั้ง',
    contact: 'ติดต่อ',
    socials: 'โซเชียลมีเดีย',
    snappyWhy: 'ทำไมต้อง Snappy',
    snappyBlog: 'บล็อก',
    snappyPricing: 'ราคา',
    snappyDemo: 'จองเดโม',
    snappyCaseStudies: 'กรณีศึกษา',
    clickToRedeem: 'คลิกเพื่อแลก',
    apply: 'ใช้',
    order: 'สั่งซื้อ',
    sortByDistance: 'เรียงตามระยะทาง',
    sortByAlpha: 'เรียงตามตัวอักษร',
    searchLocations: 'ค้นหาสถานที่',
    az: 'ก-ฮ',
    nearest: 'ใกล้ที่สุด',
    atLeast: 'อย่างน้อย',
    to: 'ถึง',
    takeout: 'ซื้อกลับบ้าน',
    or: 'หรือ',
    guest: 'ผู้เยี่ยมชม',
    back: 'ย้อนกลับ',
    other: 'อื่น ๆ',
    groups: 'กลุ่ม',
    options: 'ตัวเลือก',
    edit: 'แก้ไข',
    register: 'ลงทะเบียน',
    poweredBy: 'ขับเคลื่อนโดย',
    firstName: 'ชื่อจริง',
    lastName: 'นามสกุล',
    phone: 'โทรศัพท์',
    phoneNumber: 'เบอร์โทรศัพท์',
    address: 'ที่อยู่',
    storeHours: 'เวลาทำการ',
    onlineOrderAvailableUntil: 'สั่งออนไลน์ได้ถึง',
    mobileNumber: 'เบอร์มือถือ',
    status: 'สถานะ',
    points: 'คะแนน',
    balance: 'ยอดคงเหลือ',
    save: 'บันทึก',
    changesSaved: 'บันทึกการเปลี่ยนแปลงแล้ว',
    cancel: 'ยกเลิก',
    confirm: 'ยืนยัน',
    message: 'ข้อความ',
    loadMore: 'โหลดเพิ่มเติม',
    loading: 'กำลังโหลด...',
    expires: 'หมดอายุ',
    login: 'เข้าสู่ระบบ / ลงทะเบียน',
    tweet: 'ทวีต',
    share: 'แชร์',
    resend: '(ส่งอีกครั้งใน: {0})',
    newCode: 'รหัสใหม่',
    logout: 'ออกจากระบบ',
    fillFields: 'โปรดกรอกข้อมูลในช่องที่จำเป็นทั้งหมด',
    invalidEmail: 'อีเมลไม่ถูกต้อง',
    verify: 'รหัส 6 หลัก',
    continue: 'ดำเนินการต่อ',
    verifyCode: 'ยืนยันรหัส',
    sixDigitCode: 'รหัส 6 หลัก',
    unlimited: 'ไม่จำกัด',
    upTo: 'สูงสุด',
    selected: 'เลือกแล้ว',
    items: 'รายการ',
    amount: 'จำนวน',
    scanQRCode: 'สแกนรหัส QR สำหรับนั่งทานที่ร้าน',
    loadingQRScanner: 'กำลังโหลดเครื่องสแกน...',
    reloadQRScanner: 'โหลดซ้ำ',
    open: 'เปิด',
    open2: 'เปิด',
    closed: 'ปิด',
    closed2: 'ปิด',
    email: 'อีเมล',
    select: 'เลือก',
    ok: 'ตกลง',
    okConfirm: 'ตกลง',
    off: 'ปิด',
    app: {
      text1: 'เปิดใน',
      text2: 'แอป',
      btn: 'เปิด'
    },
    captcha: {
      main: 'เว็บไซต์นี้ได้รับการป้องกันโดย reCAPTCHA และ',
      privacy: 'นโยบายความเป็นส่วนตัว',
      and: 'และ',
      terms: 'ข้อกำหนดในการให้บริการ',
      apply: 'ของ Google'
    },
    disclaimer: {
      main: 'โดยการเข้าสู่ระบบ ฉันยอมรับ<link-tos>ข้อกำหนดในการให้บริการ</link-tos> & <link-pp>นโยบายความเป็นส่วนตัว</link-pp> และยินยอมรับข้อความ SMS และการสื่อสารดิจิทัลอื่น ๆ รวมถึงคูปอง ข้อเสนอพิเศษ และโปรโมชั่นจาก {businessName} อาจมีค่าบริการข้อความและข้อมูลมาตรฐาน',
      register: 'การคลิก REGISTER แสดงว่าคุณยอมรับ<link-tos>ข้อกำหนดในการให้บริการ</link-tos> & <link-pp>นโยบายความเป็นส่วนตัว</link-pp> ของ Snappy Snappy จะใช้ข้อมูล SMS เพื่อรักษาความปลอดภัยบัญชีของคุณและส่งการแจ้งเตือน คุณสามารถยกเลิกการรับข้อความ SMS ได้ตลอดเวลา'
    },
    addedToCart: 'เพิ่ม "{0}" ลงในตะกร้าแล้ว',
    yourOrderId: 'รหัสการสั่งซื้อของคุณคือ'
  },
  hours: {
    twentyFourHours: 'เปิดตลอด 24 ชั่วโมง',
    midNight: 'เที่ยงคืน',
    mon: 'จ.',
    tues: 'อ.',
    wed: 'พ.',
    thurs: 'พฤ.',
    fri: 'ศ.',
    sat: 'ส.',
    sun: 'อา.',
    monday: 'จันทร์',
    tuesday: 'อังคาร',
    wednesday: 'พุธ',
    thursday: 'พฤหัสบดี',
    friday: 'ศุกร์',
    saturday: 'เสาร์',
    sunday: 'อาทิตย์'
  },
  menu: {
    specialRequests: 'คำแนะนำพิเศษ',
    required: 'จำเป็น',
    optional: 'เลือกได้',
    soldOut: 'สินค้าหมด',
    selectMenu: 'โปรดเลือกเมนู',
    menuTitle: 'เมนู',
    promotionsAndRewards: 'โปรโมชันและรางวัล',
    categories: 'หมวดหมู่',
    noMenu: 'ไม่พบเมนูในร้าน',
    dropdown: 'เมนูแบบเลื่อนลง',
    unavailable: 'เมนูไม่พร้อมใช้งาน',
    available: 'เวลาที่พร้อมให้บริการ',
    dayAvailable: 'พร้อมให้บริการถัดไป',
    availableOffHours: 'เมนูนี้สามารถสั่งล่วงหน้าได้',
    menuIsExclusive: 'รายการจากเมนูที่ต่างกันไม่สามารถเพิ่มลงในตะกร้าเดียวกันได้',
    item: {
      onlyAvailable: 'พร้อมให้บริการ',
      available: 'รายการนี้มีเฉพาะเวลา {0} - {1}',
      prepTime: 'รายการนี้มักจะใช้เวลาเตรียมประมาณ {0}'
    },
    menuAvailability: 'ความพร้อมของเมนู',
    gotIt: 'รับทราบ!',
    onlyAvailable: 'เมนูนี้มีเฉพาะช่วงเวลาที่กำหนด:',
    pricingBanner: 'สั่งซื้อโดยตรงจาก {2} และประหยัดเฉลี่ยสูงสุด {0}% เมื่อเทียบกับ {1}'
  },
  cart: {
    title: 'ตะกร้า',
    startShopping: 'เริ่มสั่งอาหาร',
    continue: 'ดำเนินการต่อ',
    serviceFee: 'ค่าบริการ',
    takeOutOrder: 'คำสั่งซื้อสำหรับนำกลับบ้าน',
    backToLogin: 'กลับไปที่หน้าเข้าสู่ระบบ',
    enterYourAddress: 'ที่อยู่สำหรับจัดส่ง',
    startAdding: 'เริ่มเพิ่มรายการจากเมนูเพื่อสร้างคำสั่งซื้อของคุณ.',
    buildOrder: 'เพิ่มรายการใหม่เพื่อดำเนินการสร้างคำสั่งซื้อของคุณ',
    currentlyClosed: ' ปิดทำการ โปรดกลับมาใหม่ในช่วงเวลาทำการ.',
    delivery: 'จัดส่ง',
    pickup: 'รับเอง',
    dinein: 'นั่งทานที่ร้าน',
    estTimeHours: 'ชั่วโมง',
    estTimeMins: 'นาที',
    subtotal: 'ยอดรวมย่อย',
    deliveryFee: 'ค่าจัดส่ง',
    tbd: 'ยังไม่กำหนด',
    deliveryMinimum: 'ขั้นต่ำสำหรับจัดส่ง',
    pickupMinimum: 'ขั้นต่ำสำหรับรับเอง',
    tax: 'ภาษี',
    tip: 'ทิป',
    tipDriver: 'ทิปคนขับ',
    tipStore: 'สนับสนุนร้านค้าด้วยการให้ทิป',
    rewards: 'รางวัล',
    total: 'ยอดรวม',
    btnCheckout: 'ชำระเงิน',
    addToCart: 'เพิ่มลงในตะกร้า',
    aiRecommendationsTitle: 'แนะนำสำหรับคุณ',
    aiRecommendationsTitleGuest: 'แนะนำ',
    aiRecommendationsSubtitle: 'อิงจากคำสั่งซื้อของคุณ',
    aiRecommendationsSubtitleGuest: 'ยอดนิยมที่ร้านนี้',
    aiRecommendationsFrom: 'เริ่มต้น',
    saveCartItem: 'อัปเดตตะกร้า',
    clickToSee: 'คลิกเพื่อดูตัวเลือก',
    payWithMembership: 'ชำระด้วยสมาชิก',
    btnSubmitSubOrder: 'ส่งคำสั่งซื้อ',
    processing: 'กำลังดำเนินการคำสั่งซื้อของคุณ',
    pastOrders: 'คำสั่งซื้อที่ผ่านมา',
    discount: 'ส่วนลด',
    btnPayOrder: 'ส่งคำสั่งซื้อ',
    closeModal: 'ปิด',
    cartUnavailable: 'มีรายการในตะกร้าของคุณซึ่งไม่สามารถสั่งซื้อได้เนื่องจากความขัดแย้งหรือไม่พร้อมใช้งาน',
    storeUnavailable: 'ไม่พร้อมให้บริการในขณะนี้',
    storeClosedBtn: 'ร้านปิด',
    offHourOrderingMaybeAllowed: 'ร้านค้าปิดทำการ อย่างไรก็ตาม, คุณอาจยังสามารถกำหนดเวลาการสั่งซื้อสำหรับเวลาอื่นได้',
    advanceBookingWindow: 'ร้านค้าเปิดอยู่แต่ยังไม่รับออเดอร์ คุณสามารถจองคำสั่งซื้อสำหรับภายหลังได้',
    deliveryUnavailable: 'การจัดส่งไม่พร้อมให้บริการในขณะนี้',
    pickupUnavailable: 'การรับเองไม่พร้อมให้บริการในขณะนี้',
    tooSmallForDelivery: 'ยอดสั่งซื้อน้อยเกินไปสำหรับการจัดส่ง (ขั้นต่ำ: {0})',
    tooSmallForPickup: 'ยอดสั่งซื้อน้อยเกินไปสำหรับการรับเอง (ขั้นต่ำ: {0})',
    invalidCoupon: 'คูปองไม่ถูกต้อง',
    cartErrors: 'ข้อผิดพลาดของตะกร้า',
    removeInvalidItemToContinue: 'กรุณาลบออกเพื่อดำเนินการต่อ',
    discountNotUsed: 'ตะกร้าต้องไม่ว่างเปล่า',
    deliveryDisabled: 'การจัดส่งถูกปิดใช้งานชั่วคราวโดยร้านค้า',
    pickupDisabled: 'การรับเองถูกปิดใช้งานชั่วคราวโดยร้านค้า',
    deliveryDisabledUntil: 'การจัดส่งถูกปิดใช้งานชั่วคราว<br>โดยร้านค้าจนถึง {0}',
    pickupDisabledUntil: 'การรับเองถูกปิดใช้งานชั่วคราว<br>โดยร้านค้าจนถึง {0}',
    asapClosed: 'ปิดแล้ว · เปิด {0} เวลา {1}',
    asapPastCutoff: 'ไม่รับออเดอร์เพิ่มสำหรับวันนี้แล้ว',
    asapSuspendedToday: 'ไม่รับออเดอร์เพิ่มสำหรับวันนี้แล้ว',
    storeStoppedAcceptingOrders: 'ร้านค้าหยุดรับออเดอร์ระหว่างที่คุณกำลังชำระเงิน กรุณาเลือกเวลาจองเพื่อดำเนินการต่อ'
  },
  account: {
    accountInfo: 'ข้อมูลบัญชี',
    orderHistory: 'ประวัติการสั่งซื้อ',
    paymentMethods: 'วิธีการชำระเงิน',
    contactInfo: 'ข้อมูลติดต่อ',
    membershipInfo: 'ข้อมูลสมาชิก',
    member: 'สมาชิก',
    nonMember: 'ไม่ใช่สมาชิก',
    creditCard: 'บัตรเครดิต',
    nameOnCard: 'ชื่อบนบัตร',
    cardNumber: 'หมายเลขบัตร',
    expires: 'หมดอายุ',
    cvc: 'CVC',
    mmyy: 'เดือน / ปี',
    country: 'ประเทศที่เรียกเก็บเงิน',
    saveCard: 'บันทึกบัตร',
    addPaymentMethod: 'เพิ่มวิธีการชำระเงิน',
    deliveryDetails: 'รายละเอียดการจัดส่ง',
    noOrderHistory: 'ไม่มีประวัติการสั่งซื้อ',
    noPaymentMethods: 'ไม่มีวิธีการชำระเงิน',
    addPaymentMethodPrompt: 'โปรดเพิ่มวิธีการชำระเงิน',
    noCreditCards: 'ไม่มีวิธีการชำระเงิน',
    otherPostalCode: 'สำหรับบัตรนอกสหรัฐอเมริกาหรือแคนาดา โปรดป้อนหมายเลขใดก็ได้',
    membership: 'สมาชิก',
    history: 'ประวัติ',
    payments: 'การชำระเงิน',
    offline: 'ชำระเงินด้วยตนเอง',
    orderId: 'รหัสคำสั่งซื้อ',
    editTitle: 'แก้ไขข้อมูลส่วนตัว',
    payment: {
      title: 'ลบวิธีการชำระเงิน',
      body: 'คุณแน่ใจหรือไม่ว่าต้องการลบวิธีการชำระเงินนี้?',
      cancel: 'ยกเลิก',
      delete: 'ลบ',
      status: {
        cvcFailed: 'CVC ไม่ถูกต้อง',
        postalCodeFailed: 'รหัสไปรษณีย์ไม่ถูกต้อง',
        expiredCard: 'บัตรหมดอายุ'
      }
    },
    rewards: {
      redeemFor: 'แลกรับสำหรับ',
      rewardOptions: 'ตัวเลือกรางวัล',
      coupons: 'คูปอง',
      punchCards: 'บัตรสะสมแต้ม',
      using: 'กำลังใช้',
      remaining: 'คงเหลือ',
      free: 'ฟรี',
      purchases: 'การสั่งซื้อ',
      redeem: 'แลก',
      max: 'สูงสุด',
      points: 'คะแนน',
      credits: 'เครดิต',
      discount: 'ส่วนลด',
      yourPoints: 'คะแนนของคุณ',
      creditsEarned: 'ได้รับ {0}',
      worth: 'มูลค่า',
      insufficientFunds: 'ยอดเงินไม่เพียงพอ',
      removeFirst: 'โปรดลบตัวเลือกรางวัลที่ใช้งานอยู่ของคุณก่อน',
      punchCardRibbon: 'ซื้ออีก {0} {1} เพื่อรับ {2}!',
      selectItem: 'เลือกรายการ',
      availableInCart: 'รางวัลที่ใช้ได้จะแสดงในตะกร้า',
      availableInCartUpdated: 'คลิกที่ตะกร้าของคุณเพื่อแลกรางวัลนี้!',
      alreadyInCart: '"{0}" อยู่ในตะกร้าของคุณแล้ว',
      missingPoints: 'คุณต้องมีคะแนนอีก {0} เพื่อใช้บัตรสะสมแต้มนี้!',
      inEligible: 'คุณไม่มีสิทธิ์ใช้คูปองนี้',
      noExpiration: 'ไม่มีวันหมดอายุ',
      noLimitation: 'ไม่มีข้อจำกัด',
      buy1Get1Free: 'ซื้อ 1 แถม 1',
      buy1Get1PercentOff: 'ซื้อ 1 ชิ้นที่ 2 ลด {0}%',
      buy1Get1AmountOff: 'ซื้อ 1 ชิ้นที่ 2 ลด ${0}',
      validForSelectItems: 'ใช้ได้กับสินค้าที่เลือก',
      discountPercentOff: 'ส่วนลด {0}%',
      discountAmountOff: 'ส่วนลด {0}{1}',
      discountOff: 'ส่วนลด {0}',
      discountUpTo: '{0} สูงสุด {1}',
      maxDiscountReached: 'ถึงส่วนลดสูงสุด {0} แล้ว',
      maxDiscountOf: 'สูงสุด {0}',
      maxDiscountOfDetail: 'ส่วนลดสูงสุด {0}',
      offerExpires: 'ข้อเสนอหมดอายุ: {0}',
      loginPrompt: 'โปรดเข้าสู่ระบบเพื่อดูรางวัลของคุณ',
      inPersonRedeemable: 'รางวัลนี้สามารถแลกได้ที่ร้านค้าเท่านั้น',
      orderRewards: {
        congrats: 'ขอแสดงความยินดี!',
        coupons: 'คำสั่งซื้อของคุณได้รับคูปองโบนัส',
        lossFallback: 'เสียใจด้วยที่คุณไม่ได้รับรางวัลในครั้งนี้ โปรดลองอีกครั้งในคำสั่งซื้อถัดไป!'
      }
    }
  },
  storePage: {
    aiRecommendationsCategory: 'แนะนำสำหรับคุณ',
    aiRecommendationsCategoryGuest: 'แนะนำ',
    deliveryProvider: {
      robot: 'หุ่นยนต์',
      human: 'พนักงานจัดส่ง',
      byRobot: 'เจอกับหุ่นยนต์ที่ด้านนอก',
      byHuman: 'เจอกับพนักงานจัดส่งที่ประตู',
      recommended: 'แนะนำโดยร้านนี้',
      notSupported: 'ไม่รองรับการจัดส่งโดย {0} สำหรับที่อยู่ของคุณ',
      deliveryInstructions: 'โปรดทราบว่าหุ่นยนต์ไม่สามารถปีนบันไดได้ คุณจะต้องให้รหัสที่ส่งทางอีเมลเพื่อรับอาหารของคุณ'
    },
    error: {
      empty: 'ไม่มีอะไรให้แสดงที่นี่!',
      noResults: 'ไม่พบผลลัพธ์.',
      tryAdjusting: 'ลองปรับตัวกรองของคุณ',
      clear: 'ล้างการค้นหา'
    }
  },
  order: {
    estimatedTime: 'คำสั่งซื้อของคุณถูกส่งแล้ว, จะพร้อมให้รับในเวลา {0}',
    estimatedTimeDiff: 'คำสั่งซื้อของคุณถูกส่งแล้ว, จะพร้อมให้รับในอีกประมาณ {0}',
    successfulOrder: 'คำสั่งซื้อของคุณถูกส่งเรียบร้อยแล้ว',
    deliveryAddressInvalid: 'ที่อยู่ที่คุณป้อนไม่ถูกต้อง, โปรดลองอีกครั้ง',
    deliveryAddressMustBeSet: 'ต้องตั้งค่าที่อยู่สำหรับจัดส่งของคุณ',
    deliveryAddressMustBeInRange: 'ขออภัย, ที่อยู่ของคุณอยู่นอกพื้นที่จัดส่ง, โปรดติดต่อร้านค้าเพื่อสั่งซื้อ',
    noPaymentMethodSelected: 'โปรดเลือกวิธีการชำระเงิน',
    insufficientPoints: 'ยอดคงเหลือสมาชิกไม่เพียงพอ',
    requiresAdditionalMethod: 'ยอดคงเหลือไม่เพียงพอ, ต้องใช้วิธีการชำระเงินที่สอง',
    cardMinimumCharge: 'ต้องชำระด้วยบัตรอย่างน้อย {0} โปรดเพิ่มทิปหรือสินค้าอื่น หรือชำระคำสั่งซื้อนี้ด้วยบัตร',
    minCardChargeNote: 'ยอดชำระด้วยบัตรขั้นต่ำ {0}',
    applyMembershipInstead: 'ใช้ {0} แทน',
    noPaymentMethods: 'โปรดเลือกวิธีการชำระเงิน',
    pickUpDetails: 'รายละเอียดการรับ',
    orderDetails: 'รายละเอียดคำสั่งซื้อ',
    selectOrderType: 'เลือกประเภทคำสั่งซื้อ',
    orderPlaced: 'สั่งซื้อแล้ว',
    orderScheduled: 'เวลานัดหมาย',
    orderNotes: 'บันทึกคำสั่งซื้อ',
    pickUpTime: 'เวลารับ',
    pickUpDay: 'วันที่จะรับ',
    deliveryTime: 'เวลาจัดส่ง',
    deliveryDay: 'วันที่จะจัดส่ง',
    deliveryAddress: 'ที่อยู่สำหรับจัดส่ง',
    addressLine1: 'ที่อยู่บรรทัดที่ 1',
    addressLine2: 'ที่อยู่บรรทัดที่ 2',
    postalCode: 'รหัสไปรษณีย์',
    city: 'เมือง',
    payment: 'การชำระเงิน',
    placeOrder: 'สั่งซื้อ',
    personalDetails: 'ข้อมูลส่วนตัว',
    tableNumberSet: 'ตั้งค่าหมายเลขโต๊ะของคุณแล้ว.',
    onlyOffline: 'ร้านนี้รับชำระเงินด้วยตนเองเท่านั้น.',
    paidOffline: 'จะชำระเงินที่ร้าน',
    emailReceipt: 'ส่งใบเสร็จรับเงินทางอีเมล',
    offlineEmailReceipt: 'ส่งการยืนยันคำสั่งซื้อทางอีเมล',
    status: {
      new: 'ใหม่',
      inProgress: 'กำลังดำเนินการ',
      ready: 'พร้อม',
      cancelled: 'ยกเลิกแล้ว',
      refunded: 'คืนเงินแล้ว',
      completed: 'เสร็จสมบูรณ์แล้ว'
    },
    orderActions: {
      call: 'โทร',
      direction: 'เส้นทาง',
      orders: 'ดูคำสั่งซื้อ',
      feedbackTitle: 'พิจารณาให้ข้อเสนอแนะเกี่ยวกับคำสั่งซื้อของคุณ',
      feedbackLabel: 'ให้ข้อเสนอแนะ'
    }
  },
  iosBanner: {
    partOne: 'คลิกไอคอนแชร์',
    partTwo: 'แล้วเลือกเพิ่มไปยังหน้าจอหลัก',
    partThree: 'เพื่อติดตั้ง'
  },
  checkoutSuccess: {
    text: 'ชำระเงินสำเร็จ'
  },
  orderSubmitted: {
    text: 'ส่งคำสั่งซื้อแล้ว'
  },
  deliveryDialog: {
    title: 'รายละเอียดการจัดส่ง',
    deliverAsap: 'จัดส่งโดยเร็วที่สุด',
    schedule: 'กำหนดเวลา',
    update: 'อัปเดต',
    selectAddress: 'โปรดป้อนที่อยู่ของคุณ',
    noDeliveryProviders: 'ไม่มีผู้ให้บริการจัดส่งที่รองรับที่อยู่นั้น',
    deliveryAddressSet: 'ตั้งค่าที่อยู่จัดส่งแล้ว!',
    selectDateTime: 'โปรดเลือกวันที่และเวลาที่ถูกต้อง',
    notAvailable: 'ขออภัย รายการนี้ไม่พร้อมใช้งาน',
    pleaseSelectDate: 'โปรดเลือกวัน'
  },
  orderDialog: {
    title: 'รายละเอียดการรับ',
    deliveryTitle: 'รายละเอียดการจัดส่ง',
    pickUpAsap: 'รับโดยเร็วที่สุด',
    deliverAsap: 'จัดส่งโดยเร็วที่สุด',
    schedule: 'กำหนดเวลา',
    done: 'เสร็จสิ้น',
    selectDate: 'โปรดเลือกวัน',
    notAvailable: 'ขออภัย รายการนี้ไม่พร้อมใช้งาน',
    selectDateTime: 'โปรดเลือกวันที่และเวลาที่ถูกต้อง',
    noAvailableDays: 'ขออภัย, ไม่มีวันว่าง',
    earliestDate: 'ตั้งค่าวันที่เร็วที่สุดแล้ว',
    staleTimeBodyGroup: 'ร้านค้าไม่สามารถเตรียมออเดอร์ของคุณให้เสร็จภายใน {0} ได้ กรุณาเลือกเวลาใหม่เพื่อดำเนินการต่อ — รายการของกลุ่มและผู้ร่วมออเดอร์จะไม่เปลี่ยนแปลง',
    staleTimeBodySolo: 'ร้านค้าไม่สามารถเตรียมออเดอร์ของคุณให้เสร็จภายใน {0} ได้ กรุณาเลือกเวลาใหม่เพื่อดำเนินการต่อ',
    confirmSlot: 'ยืนยัน {0}',
    goBack: 'ย้อนกลับ'
  },
  storeLocation: {
    pickUpAt: 'รับที่',
    inStore: 'ในร้าน',
    pickUpTime: 'เวลารับ',
    deliveryTime: 'เวลาจัดส่ง',
    time: 'เวลา',
    deliverTo: 'จัดส่งไปที่',
    clickToSet: 'คลิกเพื่อตั้งค่า'
  },
  orderTypes: {
    pickup: 'รับเอง',
    delivery: 'จัดส่ง',
    dineIn: 'ทานที่ร้าน'
  },
  groupOrder: {
    title: 'สั่งอาหารร่วมกัน',
    namePlaceholder: 'ชื่อการสั่งอาหารร่วมกัน',
    from: 'จาก',
    deliverTo: 'จัดส่งไปที่',
    pickupAt: 'รับที่',
    invitePeople: 'เชิญคนอื่น',
    chooseWhoPays: 'เลือกผู้ชำระเงิน',
    paySubtitle: 'เจ้าภาพ (คุณ) จะถูกเรียกเก็บเงินสำหรับคำสั่งซื้อทั้งหมด วิธีการชำระเงินจะถูกป้อนเมื่อชำระเงิน',
    youPayForEveryone: 'คุณจ่ายแทนทุกคน',
    hostWillPayForEveryone: 'เจ้าภาพจะจ่ายแทนทุกคน',
    limitPlaceholder: 'ใส่วงเงินต่อคน (ไม่บังคับ)',
    perPerson: 'ต่อคน',
    everyonePaysThemselves: 'แต่ละคนจ่ายเอง',
    comingSoon: 'เร็วๆ นี้',
    next: 'ถัดไป',
    yourGroupOrderLink: 'ลิงก์สั่งอาหารร่วมกันของคุณ',
    copy: 'คัดลอก',
    share: 'แชร์',
    linkCopied: 'คัดลอกลิงก์แล้ว!',
    join: 'เข้าร่วมการสั่งอาหารร่วมกันของ {0}',
    spendingLimit: 'วงเงินใช้จ่าย',
    limitNoLimit: 'ไม่จำกัด',
    limitOther: 'อื่นๆ',
    joinGroupOrder: 'เข้าร่วมการสั่งอาหารร่วมกัน',
    joining: 'กำลังเข้าร่วม...',
    loginToJoin: 'เข้าสู่ระบบเพื่อเข้าร่วม',
    continueAsGuest: 'ดำเนินการต่อในฐานะแขก',
    enterYourName: 'ใส่ชื่อของคุณ',
    joinOrderDisclaimer: 'โดยคลิก "เข้าร่วมคำสั่งซื้อ" คุณยอมรับ',
    joinOrder: 'เข้าร่วมคำสั่งซื้อ',
    back: 'กลับ',
    notSet: 'ยังไม่ได้ตั้งค่า',
    cancelGroupOrder: 'ยกเลิกการสั่งอาหารร่วมกัน',
    cancelGroupOrderConfirmTitle: 'ยกเลิก {0}?',
    cancelGroupOrderConfirmBody: 'การดำเนินการนี้จะสิ้นสุดการสั่งอาหารร่วมกันสำหรับทุกคน ผู้เข้าร่วมทั้งหมดจะถูกลบออก',
    cancelGroupOrderConfirm: 'ใช่ ยกเลิก',
    cancelGroupOrderKeep: 'เก็บการสั่งอาหารร่วมกันไว้',
    cartMenuCancelGroup: 'ยกเลิกการสั่งอาหารร่วมกัน',
    cartMenuLeaveGroup: 'ออก',
    cartMenuInvite: 'เชิญคนอื่น',
    lockedBannerGuest: 'การสั่งอาหารร่วมกันนี้ถูกล็อคแล้ว กรุณาติดต่อเจ้าภาพเพื่อทำการเปลี่ยนแปลง',
    lockedBannerHost: 'ตะกร้าของคุณถูกล็อค คุณยังสามารถดำเนินการชำระเงินได้',
    unlockMyCart: 'ปลดล็อคตะกร้าของฉัน',
    othersInGroup: 'คนอื่นในกลุ่มของคุณ ({0} คน)',
    othersHaveAdded: '{0} จาก {1} คนได้เพิ่มสินค้าแล้ว',
    memberHostLabel: '(เจ้าภาพ)',
    memberReadyBadge: 'พร้อมแล้ว',
    memberWaitingBadge: 'รออยู่',
    memberErrorBadge: 'สินค้าหมด',
    memberCartHasErrors: 'มีสมาชิกในกลุ่มของคุณมีสินค้าที่หมดสต็อก กรุณานำออกเพื่อดำเนินการต่อ',
    memberNoItems: 'ยังไม่มีสินค้า',
    unlockMemberCart: 'ปลดล็อคตะกร้าของ {0}',
    removeMember: 'ลบ {0}',
    yourItems: 'สินค้าของคุณ',
    leaveConfirmTitle: 'ออกจากการสั่งอาหารร่วมกันนี้?',
    leaveConfirmBody: 'สินค้าของคุณจะถูกลบออกและเจ้าภาพจะได้รับการแจ้งเตือน',
    leaveConfirmBtn: 'ออก',
    leaveConfirmKeep: 'ยกเลิก',
    removeConfirmTitle: 'ลบ {0} ออกจากการสั่งอาหารร่วมกัน?',
    removeConfirmBody: 'สินค้าของ {0} จะถูกลบออกและพวกเขาจะได้รับการแจ้งเตือน',
    removeConfirmBtn: 'ลบ {0}',
    checkoutConfirmTitle: 'ทุกคนพร้อมแล้วหรือยัง?',
    checkoutConfirmBody: 'หากคุณดำเนินการต่อ การสั่งอาหารร่วมกันจะถูกล็อคและไม่มีใครสามารถทำการเปลี่ยนแปลงได้',
    unreadyConfirmTitleSingle: '{0} กำลังสั่งอยู่',
    unreadyConfirmTitleMulti: 'มีผู้ร่วมสั่ง {0} คนกำลังสั่งอยู่',
    unreadyConfirmBody: 'การชำระเงินจะปิดคำสั่งซื้อสำหรับทุกคน',
    unreadyConfirmWaitingOnPrefix: 'กำลังรอ ',
    unreadyConfirmWaitingOnSuffix: '',
    and: 'และ',
    andOthers: 'และอีก {0} คน',
    checkoutWithCurrentBtn: 'ชำระเงินพร้อมตะกร้าของพวกเขา',
    checkoutWithCurrentSubtext: 'คำสั่งซื้อจะรวมรายการที่พวกเขาเพิ่มไว้จนถึงตอนนี้',
    removeCartsCheckoutBtn: 'ชำระเงินโดยไม่รวมพวกเขา',
    removeCartsCheckoutSubtext: 'ตะกร้าและรายการของพวกเขาจะถูกลบออกจากคำสั่งซื้อ',
    errorRemoveUnreadyCarts: 'ไม่สามารถลบตะกร้าบางส่วนได้ โปรดลองอีกครั้ง',
    groupCartEmpty: 'กรุณาเพิ่มสินค้าอย่างน้อยหนึ่งรายการก่อนชำระเงิน',
    participantWaiting: 'รออยู่...',
    notReadyCount: 'ยังมี {0} คนที่ยังไม่พร้อม',
    goToCheckout: 'ไปที่ชำระเงิน',
    lockedInGroupOrder: 'คุณอยู่ในการสั่งอาหารร่วมกัน — ไม่สามารถเปลี่ยนประเภทคำสั่งซื้อและเวลาได้',
    checkoutProcessing: 'กำลังดำเนินการ...',
    checkoutBackBtn: 'ย้อนกลับ',
    readyBtn: 'คุณพร้อมแล้ว!',
    readyHint: 'เจ้าภาพจะสั่งอาหารให้ทุกคน',
    readyStatus: 'คุณพร้อมแล้ว!',
    imReadyBtn: 'ฉันพร้อมแล้ว!',
    addItemsBtn: 'เพิ่มสินค้า',
    lockedCheckoutBtn: 'คำสั่งซื้อกลุ่มถูกล็อค',
    lockedTimeoutBtn: 'คำสั่งซื้อถูกล็อค — หมดเวลา',
    exceedsLimit: 'เกินขีดจำกัดการสั่งอาหารร่วมกัน',
    snackParticipantLeft: '{0} ออกจากการสั่งอาหารร่วมกันแล้ว',
    errorMarkReady: 'ไม่สามารถทำเครื่องหมายตะกร้าว่าพร้อม กรุณาลองอีกครั้ง',
    errorCartLocked: 'เจ้าภาพล็อคคำสั่งซื้อแล้ว คุณไม่สามารถทำการเปลี่ยนแปลงได้ในขณะนี้',
    errorUnlockCart: 'ไม่สามารถปลดล็อคตะกร้า กรุณาลองอีกครั้ง',
    errorLockGroup: 'ไม่สามารถล็อคการสั่งอาหารร่วมกัน กรุณาลองอีกครั้ง',
    errorLeaveGroup: 'ไม่สามารถออกจากการสั่งอาหารร่วมกัน กรุณาลองอีกครั้ง',
    errorCancelGroup: 'ไม่สามารถยกเลิกการสั่งอาหารร่วมกัน กรุณาลองอีกครั้ง',
    errorUnlockMember: 'ไม่สามารถปลดล็อคตะกร้า กรุณาลองอีกครั้ง',
    errorRemoveParticipant: 'ไม่สามารถลบผู้เข้าร่วม กรุณาลองอีกครั้ง',
    dialogRemovedTitle: 'คุณถูกลบออกแล้ว',
    dialogRemovedBody: 'เจ้าภาพได้ลบคุณออกจากการสั่งอาหารร่วมกันนี้ สินค้าของคุณถูกล้างแล้ว',
    dialogLeftTitle: 'คุณออกจาก {0} แล้ว',
    dialogLeftBody: 'สินค้าของคุณถูกล้างแล้ว',
    dialogCancelledTitle: 'การสั่งอาหารร่วมกันถูกยกเลิก',
    dialogCancelledBody: 'เจ้าภาพได้ยกเลิกการสั่งอาหารร่วมกันนี้',
    dialogPaidTitle: 'สั่งซื้อเรียบร้อย!',
    dialogPaidBody: 'การสั่งอาหารร่วมกันของคุณถูกส่งเรียบร้อยแล้ว',
    dialogRecoveredTitle: 'คุณมีการสั่งอาหารร่วมกันที่กำลังดำเนินอยู่',
    dialogRecoveredHost: 'คุณเป็นเจ้าภาพ',
    dialogRecoveredGuest: 'คุณเป็นผู้เข้าร่วม',
    dialogRecoveredBtn: 'ดำเนินการต่อ',
    deadlineTitle: 'ตั้งกำหนดเวลา',
    deadlineSubtitle: 'ทุกคนควรสั่งอาหารภายในเมื่อไหร่?',
    deadlineDayLabel: 'สั่งภายใน (วัน)',
    deadlineTimeLabel: 'สั่งภายใน (เวลา)',
    noDeadline: 'ไม่มีกำหนดเวลา',
    noDeadlineSet: 'ยังไม่ได้ตั้งกำหนดเวลา',
    deadlineSpecificTime: 'เวลาที่กำหนด',
    orderDeadline: 'กำหนดเวลาสั่งอาหาร',
    orderBeforeDeadline: 'สั่งก่อน {0}',
    peopleCanOrderAnytime: 'ทุกคนสามารถสั่งอาหารได้ตลอดเวลา',
    notAvailableScheduled: 'ไม่พร้อมสำหรับเวลาที่กำหนดนี้',
    deadlineNotAvailableNow: 'ไม่สามารถตั้งกำหนดเวลาได้เมื่อเวลาจัดส่งถูกตั้งเป็น ตอนนี้',
    noAvailableDeadlineTimes: 'ไม่มีเวลาสำหรับกำหนดเวลา กรุณาเลือกเวลาจัดส่งที่ช้ากว่านี้',
    noSpendingLimit: 'ไม่มีวงเงินใช้จ่าย',
    spendingLimitValue: 'วงเงิน {0}',
    dialogChangedTitle: 'เจ้าภาพอัปเดตคำสั่งซื้อแล้ว',
    dialogChangedToDelivery: 'เปลี่ยนเป็นการจัดส่ง',
    dialogChangedToPickup: 'เปลี่ยนเป็นรับเอง',
    dialogChangedTime: 'เวลาเปลี่ยนจาก {0} เป็น {1}',
    dialogChangedTimeSet: 'ตั้งเวลานัดหมายเป็น {0}',
    dialogChangedTimeCleared: 'ลบเวลานัดหมายแล้ว (เร็วที่สุด)',
    timeChangedLabel: 'เวลาเปลี่ยนแปลง',
    timeChangedToLabel: 'เวลาเปลี่ยนเป็น',
    confirmChangeToDelivery: 'เปลี่ยนเป็นการจัดส่ง?',
    confirmChangeToPickup: 'เปลี่ยนเป็นรับเอง?',
    confirmChangeTypeBody: 'การดำเนินการนี้จะอัปเดตประเภทคำสั่งซื้อสำหรับทุกคนในกลุ่ม',
    asap: 'เร็วที่สุด',
    orderAsap: 'สั่งโดยเร็วที่สุด',
    now: 'ตอนนี้',
    staleTimeTitle: 'เวลาที่คุณเลือกไม่สามารถใช้ได้อีกต่อไป',
    staleTimeNearestSlotLabel: 'เวลาที่ใกล้เคียงที่สุดที่ว่าง',
    staleTimeChooseAnother: 'เลือกเวลาอื่น',
    errorResetSchedule: 'ไม่สามารถอัปเดตเวลาได้ กรุณาลองใหม่',
    errorUpdateSchedule: 'ไม่สามารถอัปเดตเวลาได้ กรุณาลองใหม่',
    errorUpdateScheduleConflict: 'ไม่สามารถอัปเดตได้ในขณะนี้ กรุณาตรวจสอบแล้วลองใหม่อีกครั้ง',
    discountsAtCheckout: 'ส่วนลดจะถูกใช้เมื่อชำระเงิน',
    deliveryFeeAtCheckout: 'คำนวณเมื่อชำระเงิน',
    feesCalculatedAtCheckout: 'ภาษี ค่าธรรมเนียม และส่วนลดจะคำนวณเมื่อชำระเงิน',
    exceedsSpendingLimit: 'สินค้านี้จะเกินวงเงินที่เจ้าภาพกำหนด',
    cartFinalized: 'คำสั่งซื้อกลุ่มของคุณเสร็จสิ้นแล้ว ไม่สามารถเพิ่มสินค้าได้อีก',
    noDeadlineSlots: 'ไม่มีช่วงเวลาที่ว่างสำหรับการตั้งเวลาสิ้นสุด',
    errorUpdateDeadline: 'ไม่สามารถอัปเดตเวลาสิ้นสุดได้ กรุณาลองใหม่',
    deadlineUpdated: 'อัปเดตเวลาสิ้นสุดการสั่งซื้อ: {0}',
    deadlineRemoved: 'อัปเดตเวลาสิ้นสุดการสั่งซื้อแล้ว',
    shareGroupOrder: 'เข้าร่วมคำสั่งซื้อกลุ่มของฉัน!',
    memberLocked: 'ล็อคแล้ว',
    snackParticipantLeftHost: '{0} ออกจากการสั่งอาหารร่วมกันแล้ว',
    tooltipBadgeNew: 'ใหม่',
    tooltipTitle: 'วิธีการทำงานของคำสั่งซื้อกลุ่ม',
    tooltipScene1Caption: 'เริ่มคำสั่งซื้อกลุ่มจากหน้าเมนู',
    tooltipScene2Caption: 'กำหนดเส้นตาย — และใครเป็นคนจ่าย',
    tooltipScene3Caption: 'แชร์ลิงก์ หรือให้เพื่อนสแกนเพื่อเข้าร่วม',
    tooltipScene4Caption: 'ทุกคนเพิ่มลงตะกร้าเดียว ชำระเงินครั้งเดียว',
    tooltipStartBtn: 'เริ่มคำสั่งซื้อกลุ่ม',
    tooltipGotItBtn: 'เข้าใจแล้ว',
    tooltipDemoPeopleJoined: '{0} คนเข้าร่วมแล้ว',
    tooltipDemoDeadlineTimeExample: 'ศุกร์ 10 ก.ค. · 12:30 น.',
    tooltipDemoPaySub: 'คุณจ่าย · จำกัด $15 ต่อคน',
    tooltipDemoLinkExample: 'gosnappy.io/g/tonnys-order…',
    tooltipDemoGroupCartLabel: 'ตะกร้ากลุ่ม',
    tooltipDemoOneCheckout: 'ชำระเงินครั้งเดียว — คุณจ่าย',
    sheetTitle: 'การสั่งกลุ่มมาแล้ว',
    sheetSubtitle: 'สั่งด้วยกัน — ตะกร้าเดียวที่ใช้ร่วมกัน ชำระเงินครั้งเดียว',
    sheetBullet1: 'ตั้งกำหนดเวลาสั่งซื้อ',
    sheetBullet2: 'คุณจ่าย — หรือกำหนดวงเงินการใช้จ่าย',
    sheetBullet3: 'เชิญด้วยลิงก์หรือคิวอาร์โค้ด',
    sheetNotNowBtn: 'ไว้ทีหลัง',
    showHowItWorks: 'ดูวิธีการทำงาน',
    hostSetsTip: 'ในฐานะเจ้าของกลุ่ม คุณเป็นผู้กำหนดทิปสำหรับออเดอร์กลุ่มทั้งหมด',
    checkoutErrorGeneric: 'การชำระเงินล้มเหลว กรุณาลองใหม่อีกครั้ง',
    checkoutErrorInvalidCart: 'มีสินค้าบางรายการในตะกร้าที่ต้องตรวจสอบก่อนชำระเงิน',
    checkoutErrorOutOfStock: 'สินค้าบางรายการหมดแล้ว กรุณานำออกแล้วลองใหม่อีกครั้ง',
    checkoutErrorMissingSelection: 'กรุณาตรวจสอบตัวเลือกของสินค้าในตะกร้า',
    checkoutErrorInvalidItem: 'สินค้าในตะกร้ารายการหนึ่งไม่ถูกต้องแล้ว กรุณานำออกแล้วลองใหม่อีกครั้ง',
    checkoutErrorPaymentDeclined: 'บัตรของคุณถูกปฏิเสธ กรุณาลองวิธีการชำระเงินอื่น',
    checkoutErrorPaymentFraud: 'วิธีการชำระเงินนี้ถูกปฏิเสธโดยผู้ออกบัตร กรุณาลองวิธีอื่น',
    checkoutErrorCardDetails: 'ข้อมูลบัตรมีปัญหา กรุณาตรวจสอบแล้วลองใหม่อีกครั้ง',
    checkoutErrorCardExpired: 'บัตรนี้หมดอายุแล้ว กรุณาลองวิธีการชำระเงินอื่น',
    checkoutErrorPaymentGateway: 'ไม่สามารถดำเนินการชำระเงินได้ กรุณาลองใหม่อีกครั้ง',
    checkoutErrorNotOpen: 'ออเดอร์กลุ่มนี้ไม่ได้เปิดอยู่แล้ว',
    checkoutErrorVersionConflict: 'ออเดอร์กลุ่มมีการเปลี่ยนแปลงระหว่างที่คุณชำระเงิน กรุณาตรวจสอบแล้วลองใหม่อีกครั้ง',
    checkoutErrorInProgress: 'กำลังดำเนินการชำระเงินอยู่แล้ว',
    checkoutErrorEmpty: 'ตะกร้าของกลุ่มว่างเปล่า',
    checkoutErrorBlocked: 'ผู้เข้าร่วมบางคนยังไม่พร้อม',
  },
  weChat: {
    warning: 'โปรดออกจากหน้านี้และใช้ WeChat Scanner เพื่อสแกนรหัส QR',
    title: 'ป้อนหมายเลขโต๊ะ'
  },
  checkout: {
    addCoupon: 'เพิ่มคูปอง',
    couponCode: 'รหัสคูปอง',
    title: 'ส่งคำสั่งซื้อ',
    description: 'คุณพร้อมที่จะส่งคำสั่งซื้อแล้วใช่หรือไม่?',
    confirmCancel: 'ไม่',
    confirmApprove: 'ใช่',
    onlinePay: 'ชำระเงินออนไลน์',
    weChatPay: 'WeChat Pay',
    unitNumber: 'หมายเลขห้อง (ไม่บังคับ)',
    primaryMethod: 'การชำระเงิน',
    secondaryMethod: 'วิธีการชำระเงินที่สอง',
    credits: 'กระเป๋าเงินร้านค้า',
    orderHints: 'เช่น ข้อจำกัดด้านอาหาร',
    deliveryHints: 'เช่น กดกริ่งหลังจากจัดส่ง, วางไว้ข้างระเบียง, หมายเลขกริ่ง, เป็นต้น',
    deliveryOptions: 'ตัวเลือกการจัดส่ง',
    deliveryInstructions: 'คำแนะนำในการจัดส่ง',
    orderDisposables: 'ช้อนส้อม, หลอด, ฯลฯ',
    deliveryDisposables: 'ช้อนส้อมแบบใช้แล้วทิ้ง',
    disposablesIncluded: 'รายการเหล่านี้จะไม่รวมอยู่ด้วยเว้นแต่คุณจะขอ',
    noPaymentMethods: 'ไม่มีตัวเลือกการชำระเงิน<br>โปรดติดต่อ {0}',
    billLoadError: 'เราไม่สามารถโหลดยอดรวมคำสั่งซื้อของคุณได้ กรุณาลองใหม่อีกครั้ง',
    applePayFailed: 'ไม่สามารถเริ่ม Apple Pay ได้ กรุณาลองใหม่อีกครั้งหรือเลือกวิธีชำระเงินอื่น',
    retry: 'ลองอีกครั้ง',
    confirmDialog: {
      total: 'ยอดรวม',
      name: 'ชื่อร้าน',
      location: 'ที่ตั้งร้าน',
      deliveryInfo: 'ข้อมูลการจัดส่ง',
      deliveryAddress: 'ที่อยู่สำหรับจัดส่ง',
      deliveryPhone: 'เบอร์โทรศัพท์สำหรับจัดส่ง',
      scheduled: 'กำหนดไว้สำหรับ',
      pay: 'ชำระเงิน',
      pickupTitle: 'รับสินค้าที่ร้าน?',
      pickupBody: 'โปรดยืนยันว่าคุณจะมารับคำสั่งซื้อนี้ที่ร้าน',
      pickupTime: 'เวลารับสินค้า:',
      beforeYouArrive: 'ก่อนเดินทางมาถึง',
      yesPickUp: 'ใช่ ฉันจะไปรับ',
      goBack: 'กลับ'
    },
    deliveryMessage: {
      leave_at_door: 'วางไว้หน้าประตู',
      meet_at_door: 'พบที่หน้าประตู',
      meet_outside: 'พบกันด้านนอก'
    },
    couponTypes: {
      title: 'คูปองของคุณจำกัดตัวเลือกการชำระเงินของคุณไว้ที่:',
      membership: 'กระเป๋าเงินร้านค้า',
      online: 'บัตรเครดิต',
      wechat: 'WeChat',
      offline: 'ชำระเงินด้วยตนเอง'
    }
  },
  qr: {
    manulInput: 'เครื่องสแกนไม่ทำงาน? โปรดป้อนหมายเลขโต๊ะของคุณ.',
    selectTable: 'หมายเลขโต๊ะของคุณ',
    select: 'ยืนยัน'
  },
  apps: {
    giftcard: 'บัตรของขวัญ',
    coupons: 'ซื้อคูปอง',
    deposit: 'เติมเงิน',
    lineup: 'รายการรอคิว',
    reservation: 'การจอง'
  },
  requestService: {
    openButton: 'เรียกใช้บริการ',
    title: 'ทำรายการที่ต้องการจากพนักงานเสิร์ฟของคุณ',
    sent: 'ส่งคำขอแล้ว',
    login: 'ต้องเข้าสู่ระบบเพื่อใช้คุณสมบัตินี้',
    tableNeeded: 'โปรดตั้งค่าหมายเลขโต๊ะของคุณเพื่อใช้คุณสมบัตินี้'
  },
  sharedCart: {
    bannerLabel: 'โต๊ะร่วม · โต๊ะ #{0}',
    live: 'สด',
    staleItemWarning: 'อัพเดทโดยลูกค้าอื่น — ตรวจสอบก่อนบันทึก',
    sentToKitchen: 'ส่งไปที่ครัวแล้ว',
    roundSentToKitchen: 'รอบที่ {0} · ส่งไปที่ครัวแล้ว',
    alreadyOrdered: 'สั่งไปแล้ว',
    itemCount: '{0} รายการ',
    stillOrdering: 'กำลังเพิ่มตอนนี้',
    sending: 'กำลังส่ง...',
    reconnected: 'เชื่อมต่อกับโต๊ะร่วม {0} อีกครั้งแล้ว',
    joinedTitle: 'คุณเข้าร่วมโต๊ะนี้แล้ว!',
    joinedBody: 'ตอนนี้คุณกำลังแชร์ออเดอร์ของโต๊ะนี้กับทุกคนที่นี่',
    completedTitle: 'ชำระเงินสำหรับออเดอร์โต๊ะแล้ว!',
    completedBody: 'การชำระเงินสำหรับโต๊ะนี้เสร็จสมบูรณ์แล้ว ขอบคุณ!',
    billAtPosTitle: 'ส่งบิลไปที่แคชเชียร์แล้ว',
    billAtPosBody: 'บิลของโต๊ะคุณถูกส่งไปที่เคาน์เตอร์แล้ว กรุณาชำระเงินที่นั่นเพื่อทำรายการให้เสร็จสมบูรณ์',
    cancelledTitle: 'สิ้นสุดเซสชั่นโต๊ะ',
    cancelledBody: 'เซสชั่นตะกร้าร่วมของโต๊ะนี้หมดอายุแล้ว กรุณาสแกน QR code เพื่อเริ่มเซสชั่นใหม่',
    roundFired: 'ส่งรายการไปที่ครัวแล้ว',
    errorFireRound: 'ส่งไปที่ครัวไม่สำเร็จ กรุณาลองอีกครั้ง',
    errorItemChanged: 'มีคนอื่นเปลี่ยนแปลงรายการนี้แล้ว — รีเฟรชเป็นเวอร์ชันล่าสุดแล้ว กรุณาลองอีกครั้ง',
    errorMutateCart: 'ดำเนินการไม่สำเร็จ กรุณาลองอีกครั้ง',
    errorSessionClosed: 'โต๊ะนี้ถูกปิดไปแล้ว',
    sharedTable: 'โต๊ะร่วม',
    sharedTableActive: '● โต๊ะร่วมกำลังใช้งาน',
    tableLabel: 'โต๊ะ {0}',
    errorStartSharedTable: 'ไม่สามารถเริ่มโต๊ะร่วมได้ กรุณาลองอีกครั้ง',
  },
}